import React from 'react';
import {Tooltip, Typography} from "@mui/material";
import {ReactComponent as FolderSvg} from "../../../../../assets/icons/catalog.svg";
import {ReactComponent as ListSvg} from "../../../../../assets/icons/list.svg";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {DataSource} from "../../../../../models/models";
import {
    AllDataSourcesButton,
    SidebarDataSourceItem,
    SidebarDataSourcesContainer,
    SidebarDataSourcesHeader,
    SidebarDataSourcesList
} from "./SidebarDataSources.styled";

interface SidebarDataSourcesProps {
    dataSources: DataSource[];
    isSystemAdmin: boolean;
}

const SidebarDataSources = ({dataSources, isSystemAdmin}: SidebarDataSourcesProps) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const isDataSourcesListActive = location.pathname === '/data-sources/list';

    const handleOpenDataSource = (dataSourceId: number) => {
        navigate(`/data-sources/${dataSourceId}/documents`, {
            state: {
                backPath: isSystemAdmin
                    ? '/admin/data-sources/list'
                    : '/data-sources/list',
            },
        });
    };

    if (dataSources.length === 0) return null;

    return (
        <SidebarDataSourcesContainer>
            <SidebarDataSourcesHeader>
                <Typography variant='h6' component={'span'}>{t('sidebar.dataSources')}</Typography>

                <Tooltip title={t('sidebar.goToAllDataSources')}>
                    <AllDataSourcesButton
                        onClick={() => navigate('/data-sources/list')}
                        disabled={isDataSourcesListActive}
                        color='primary'
                    >
                        <ListSvg />
                    </AllDataSourcesButton>
                </Tooltip>
            </SidebarDataSourcesHeader>

            <SidebarDataSourcesList>
                {dataSources.slice(0, 3).map((dataSource) => (
                    <SidebarDataSourceItem
                        key={dataSource.id}
                        onClick={() => handleOpenDataSource(dataSource.id)}
                        startIcon={<FolderSvg />}
                        sx={{ justifyContent: 'flex-start' }}
                    >
                        <span>{dataSource.name}</span>
                    </SidebarDataSourceItem>
                ))}
            </SidebarDataSourcesList>

        </SidebarDataSourcesContainer>
    );
};

export default SidebarDataSources;